import { createValidateFormError } from './createSubmitErrors';
export const validateForm = async formStore => {
  formStore.validate();
  if (formStore.invalid) {
    throw createValidateFormError();
  }
};